import styled from "styled-components";

export const FullPageCenteredContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 25px;
  height: 100svh;
  width: 100svw;
  color: ${({ theme }) => theme.colors.contentSubtle};
`;
